import { CenteredLoadingIndicator } from "../../views/molecules/Molecules"
import { useSelector } from "react-redux"
import React from "react"
import ReadArticle from "../../views/library/ReadArticle"
import slugify from "slugify"
import ContentTypes from "utils/ContentTypes"
import { getLibraryIsLoaded } from "reducers/library"
import { CenteredLayout } from "../../views/atoms/Layouts"
import { getLibraryCategories } from "derivedSelectors/librarySelectors"
import { useHistory, useParams } from "react-router-dom"
import { MasterLayout } from "../../views/atoms/layouts/MasterLayout"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"

const findCategoryBySlug = (categories, categorySlug) =>
  categories.find((c) => slugify(c.fields.title) === categorySlug)

const findArticleBySlug = (categories, articleSlug) =>
  categories
    .map((c) => c.fields.subCategories.map((s) => s.fields.articles))
    .flat(Infinity)
    .filter((a) => a !== undefined)
    .find((a) => slugify(a.fields.title) === articleSlug)

const findSubcategoryForArticle = (categories, article) =>
  categories
    .map((c) => c.fields.subCategories)
    .flat(Infinity)
    .filter((s) => s !== undefined)
    .find((s) => s.fields.articles.includes(article))

const isVideo = (article) => article.sys.contentType.sys.id === ContentTypes.VIDEO

const ReadArticleContainer = () => {
  const history = useHistory()
  const params = useParams<{ category: string; article: string }>()

  const categories = useSelector(getLibraryCategories)
  const isLoaded = useSelector(getLibraryIsLoaded)

  const article = findArticleBySlug(categories, params.article)
  if (!article) {
    history.push("/404")
    return null
  }

  const category = findCategoryBySlug(categories, params.category)
  const subCategory = findSubcategoryForArticle(categories, article)

  return (
    <MasterLayout header={null}>
      <CenteredLayout>
        {!isLoaded ? (
          <CenteredLoadingIndicator />
        ) : (
          <ReadArticle
            articleBody={article.fields.body}
            articleTitle={article.fields.title}
            categoryTitle={category.fields.title}
            hasManySubCategories={category.fields.subCategories.length > 1}
            isVideo={isVideo(article)}
            lastUpdated={article.sys.updatedAt}
            subCategory={subCategory}
            videoUrl={article.fields.url}
          />
        )}
      </CenteredLayout>
    </MasterLayout>
  )
}

export { isVideo }

export default ReadArticleContainer
